import React, { useEffect, useState, useRef } from 'react';
import { motion } from 'framer-motion';
import '../styles/PromoSection.css';

const PromoSection = () => {
  const ref = useRef(null);
  const [isInView, setIsInView] = useState(false);

  // Scroll detection to check if the element is in view
  useEffect(() => {
    const handleScroll = () => {
      if (ref.current) {
        const rect = ref.current.getBoundingClientRect();
        const windowHeight = window.innerHeight;

        if (rect.top <= windowHeight * 0.8) {
          setIsInView(true);
        }
      }
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <section ref={ref} className="promo-section">
      {/* Background Image */}
      <motion.div
        className="promo-bg"
        style={{
          backgroundImage: 'url("background5.webp")', // Replace with your background image path
          backgroundSize: 'cover',
          backgroundPosition: 'center',
        }}
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 1 }}
      />

      {/* Foreground Overlay */}
      <div className="promo-overlay"></div>

      <motion.div
        className="promo-container"
        initial={{ x: isInView ? 0 : -100, opacity: isInView ? 1 : 0 }}
        animate={{ x: 0, opacity: 1 }}
        transition={{ duration: 0.8 }}
      >
        {/* Left Side - Roulette and Cards */}
        <div className="promo-left">
          <img src="wheel2.webp" alt="Roulette Wheel" className="wheel2" />
          <img src="wheelcircle.webp" alt="Roulette Wheel" className="wheelcircle" />
          <img src="coins.webp" alt="Playing Cards" className="coins" />
        </div>

        {/* Right Side - Text and Buttons */}
        <div className={`promo-right ${isInView ? 'animate-right' : ''}`}>
          <h1 className="promo-heading">
            Your Friendly <br /> Stake <span className="highlight">Mate</span>
          </h1>
          <p className="promo-subtext">
            Partnering with Top Brands to Offer <br />
            The Fastest Withdrawal Service.
          </p>
          <hr className="promo-divider" />
          <p className="whatsapp-text">We Deal Only On WhatsApp</p>

          {/* WhatsApp Contact Buttons */}
          <div className="whatsapp-buttons">
            <a href={`https://wa.me/918949471009`} className="whatsapp-button">+44 7418 375266</a>
            <a href={`https://wa.me/918949471009`} className="whatsapp-button">+44 7476 885849</a>
          </div>
        </div>
      </motion.div>

    </section>
  );
};

export default PromoSection;
